import { createSlice } from '@reduxjs/toolkit';

type ModalStateType = {
  isModalOpened: boolean;
};

const initialState: ModalStateType = {
  isModalOpened: false,
};

const modalSlice = createSlice({
  name: 'modalState',
  initialState,
  reducers: {
    openModal: (state: ModalStateType) => {
      return { ...state, isModalOpened: true };
    },
    closeModal: (state: ModalStateType) => {
      return { ...state, isModalOpened: false };
    },
  },
});

export const selectIsModalOpened = (state: any): ModalStateType => state.modalState;
export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
